module.exports = __webpack_public_path__ + "static/media/01.d6062cc9.jpg";